module.exports = __webpack_public_path__ + "assets/img/ee0a-bh.svg";